import { useEffect, useState } from "react";

// Re-renders on an interval so relative timestamps ("2 minutes ago") keep
// counting up instead of freezing at whatever they said when rendered.
export const useNow = (intervalMs = 15 * 1000) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  return now;
};
